import type { RouteRecordRaw } from 'vue-router';

export const employeeRoutes: RouteRecordRaw = {
  path: '/employee',
  component: () => import('./EmployeeLayout.vue'),
  meta: {userType: 'EMPLOYEE_PORTAL_USER'},
  children: [
    {
      path: '',
      name: 'employee-home',
      component: () => import('./views/Dashboard.vue'),
      meta: {crumb: 'employee.nav.dashboard'},
    },
    {
      path: 'profile',
      name: 'employee-profile',
      component: () => import('./views/Profile.vue'),
      meta: {crumb: 'employee.nav.profile'},
    },
    {
      path: 'customers',
      name: 'employee-customers',
      component: () => import('./views/Customers.vue'),
      meta: {crumb: 'employee.nav.customers'},
    },
    {
      path: 'customers/:id',
      name: 'employee-customer',
      component: () => import('./views/CustomerDetail.vue'),
      props: true,
      meta: {crumb: 'employee.nav.customers'},
    },
    {
      path: 'whitelist',
      name: 'employee-whitelist',
      component: () => import('./views/Whitelist.vue'),
      meta: {crumb: 'employee.nav.whitelist'},
    },
  ],
};
